import axios from 'axios';
const httpClient = axios.create({
	baseURL: '/apps3/clavis'
});
export default {
	init() {
		return httpClient.get('/init');
	},
	getStockData(params) {
		return httpClient.get('/search', { params });
	}
};
